module.exports = __webpack_public_path__ + "img/icon_ai3.5f11c43b.png";